import { CostsFilters } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: CostsFilters = {
  search: '',
  campaign: '',
  status: '',
  period: '',
  limit: '',
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const getCampaignTypeOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.revshare.costs.filters.allCampaignTypes') },
  { key: 'CPL', label: 'CPL' },
  { key: 'RevShare', label: 'RevShare' },
];

export const getStatusOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'in_pending', label: t('partner.revshare.costs.filters.statusPending') },
  { key: 'paid', label: t('partner.revshare.costs.filters.statusApproved') },
];

export const getPeriodOptions = (t: (key: string) => string): FilterOption[] => [
  { key: '7days', label: t('partner.revshare.income.filters.period7days') },
  { key: '14days', label: t('partner.revshare.income.filters.period14days') },
  { key: '30days', label: t('partner.revshare.income.filters.period30days') },
  { key: '90days', label: t('partner.revshare.income.filters.period90days') },
];

export const getLimitOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'last30days', label: t('partner.revshare.costs.filters.limitLast30days') },
  { key: 'last90days', label: t('partner.revshare.costs.filters.limitLast90days') },
  { key: 'lastYear', label: t('partner.revshare.costs.filters.limitLastYear') },
  { key: 'all', label: t('partner.revshare.costs.filters.limitAll') },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: 'ID', key: 'id' },
  { name: t('partner.revshare.costs.table.campaign'), key: 'campaign' },
  { name: t('partner.revshare.costs.table.amountTransaction'), key: 'amount' },
  { name: t('partner.revshare.costs.table.comment'), key: 'comment' },
  { name: t('partner.revshare.costs.table.status'), key: 'status' },
  { name: t('partner.revshare.costs.table.date'), key: 'date' },
];

export const getCampaignTypeColors = () => ({
  CPL: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
  RevShare: { bg: 'bg-[rgba(0,111,238,0.2)]', text: 'text-partner' },
});

export const getStatusColors = () => ({
  paid: { bg: 'bg-[rgba(23,201,100,0.2)]', text: 'text-success', dot: 'bg-success' },
  in_pending: { bg: 'bg-[rgba(245,165,36,0.2)]', text: 'text-warning', dot: 'bg-warning' },
  // Legacy mappings for UI display
  approved: { bg: 'bg-[rgba(23,201,100,0.2)]', text: 'text-success', dot: 'bg-success' },
  pending: { bg: 'bg-[rgba(245,165,36,0.2)]', text: 'text-warning', dot: 'bg-warning' },
  cancelled: {
    bg: 'bg-[rgba(243,18,96,0.2)]',
    text: 'text-auth-strength-weak',
    dot: 'bg-auth-strength-weak',
  },
});
